// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { createPO, deletePO, editPO, getPOList, getPONumber } from '~/thunks/po/poThunk';

export interface IPOState {
  isRefreshPOList: boolean;
}

export const initialState: IPOState = {
  isRefreshPOList: false,
};

const poSlice = createSlice({
  name: 'po',
  initialState,
  reducers: {
    setRefreshPOList(state, action) {
      state.isRefreshPOList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get po list
    builder
      .addCase(getPOList.pending, (_state) => {})
      .addCase(getPOList.fulfilled, (_state) => {})
      .addCase(getPOList.rejected, (_state) => {});

    // DELETE: Delete PO
    builder
      .addCase(deletePO.pending, (_state) => {})
      .addCase(deletePO.fulfilled, (state) => {
        state.isRefreshPOList = true;
      })
      .addCase(deletePO.rejected, (_state) => {});

    // GET: Get po number
    builder
      .addCase(getPONumber.pending, (_state) => {})
      .addCase(getPONumber.fulfilled, (_state) => {})
      .addCase(getPONumber.rejected, (_state) => {});

    // POST: CREATE PO
    builder
      .addCase(createPO.pending, (_state) => {})
      .addCase(createPO.fulfilled, (_state) => {
        _state.isRefreshPOList = true;
      })
      .addCase(createPO.rejected, (_state) => {});

    // PUT: EDIT PO
    builder
      .addCase(editPO.pending, (_state) => {})
      .addCase(editPO.fulfilled, (_state) => {
        _state.isRefreshPOList = true;
      })
      .addCase(editPO.rejected, (_state) => {});
  },
});

// Action
export const poActions = poSlice.actions;

// Selectors
export const selectIsRefreshPOList = (state: RootState) => state.po.isRefreshPOList;

// Reducer
const poReducer = poSlice.reducer;
export default poReducer;
